import { useEffect, useSyncExternalStore } from 'react';
import { applyColorScheme, getStoredColorScheme, resolveColorScheme, storeColorScheme, } from './color_scheme.constants';
const listeners = new Set();
const getServerSnapshot = () => 'light';
const notifyListeners = () => {
    listeners.forEach((listener) => listener());
};
const subscribe = (onStoreChange) => {
    if (typeof window === 'undefined') {
        return () => undefined;
    }
    const mediaQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    const refreshColorScheme = () => {
        applyColorScheme(resolveColorScheme());
        onStoreChange();
    };
    const handleVisibilityChange = () => {
        if (!document.hidden) {
            refreshColorScheme();
        }
    };
    const handleSystemColorSchemeChange = () => {
        if (!getStoredColorScheme()) {
            applyColorScheme(resolveColorScheme());
            onStoreChange();
        }
    };
    listeners.add(onStoreChange);
    window.addEventListener('focus', refreshColorScheme);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener('change', handleSystemColorSchemeChange);
    return () => {
        listeners.delete(onStoreChange);
        window.removeEventListener('focus', refreshColorScheme);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener('change', handleSystemColorSchemeChange);
    };
};
const setColorScheme = (colorScheme) => {
    storeColorScheme(colorScheme);
    applyColorScheme(colorScheme);
    notifyListeners();
};
export const useColorScheme = () => {
    const colorScheme = useSyncExternalStore(subscribe, resolveColorScheme, getServerSnapshot);
    const isDarkMode = colorScheme === 'dark';
    useEffect(() => {
        applyColorScheme(colorScheme);
    }, [colorScheme]);
    const toggleColorScheme = () => {
        setColorScheme(isDarkMode ? 'light' : 'dark');
    };
    return { colorScheme, isDarkMode, setColorScheme, toggleColorScheme };
};
//# sourceMappingURL=use_color_scheme.hook.js.map